<template>
  <div>
    <UserInput
      v-show="ShowState == 0 || ShowState == 2"
      v-on:childToParent="getDataFromServer"
      :ShowMessage="showMessage"
    ></UserInput>
    <Directories v-if="ShowState == 0"></Directories>
    <Loading v-if="ShowState == 1"></Loading>
    <Results
      v-if="ShowState == 2"
      :LocationName="LocationName"
      :LocatationCity="locationCity"
      :LocationAddress="LocationAddress"
      :resultsData="resultsData"
      :key="jobID"
    ></Results>
  </div>
</template>

<script>
import UserInput from "./components/UserInput.vue";
import Directories from "./components/Directories.vue";
import Results from "./components/Results.vue";
import Loading from "./components/Loading.vue";
//import PieChart from "./components/PieChart.vue";
import scannerAPI from "./helper/scannerAPI";
// import PieChart from "./components/PieChart.vue";
// import { tsParenthesizedType } from '@babel/types';

export default {
  name: "App",
  data() {
    return {
      ShowState: 0,
      showMessage: false,
      resultsData: [],
      LocationName: "",
      LocationAddress: "",
      jobID: "",
      jobStatues: {},
      chartData: {
        Books: 24,
        Magazine: 30,
        Newspapers: 10,
        locationCity: "",
      },
    };
  },
  components: {
    UserInput,
    Directories,
    Results,
    Loading,
  },
  mounted() {
    this.ShowState = 0;
    this.resultsData = [];
    this.jobID = "";
  },
  methods: {
    //{ "locationName": this.locationName, "Address": this.Address, "City": this.City }
    getDataFromServer(UserInput) {
      this.ShowState = 1;
      this.showMessage = false;
      this.jobID = new Date().getTime().toString();
      this.LocationName = UserInput.locationName;
      this.locationCity = UserInput.City;
      this.LocationAddress = UserInput.Address + "," + UserInput.City;
      scannerAPI
        .createJob(UserInput.locationName, UserInput.Address, UserInput.City)
        .then((JobNumber) => {
          this.jobID = JobNumber;
          this.doLongPoll();
        });
      // console.log(UserInput);
      // window.setTimeout(() => {
      //                       this.ShowState = 2;
      //                       this.createFakeResults();
      //                     }, 1000);
    },
    doLongPoll() {
      scannerAPI.getJobInfo(this.jobID).then((jobInfo) => {
        //console.log(jobInfo);
        //failed
        if (jobInfo == "failed") {
          this.ShowState = 0;
          this.showMessage = true;
        }
        if (jobInfo != "finished") {
          window.setTimeout(() => {
            this.doLongPoll();
          }, 1000);
        } else {
          scannerAPI.getResult(this.jobID).then((result) => {
            this.resultsData = result;
            this.ShowState = 2;
          });
        }
      });
    },
    createFakeResults() {
      this.resultsData = [
        {
          Platform: "Google",
          Present: true,
          CorrectName: true,
          Address: true,
          CorrectAddress: false,
          Phone: true,
          Website: true,
          NameFound: "Hungry Lion Eloff Street",
          AddressFound: "Address: 80 Eloff St, Hillbrow, Johannesburg, 2000",
        },
        {
          Platform: "Waze",
          Present: true,
          CorrectName: true,
          Address: true,
          CorrectAddress: false,
          Phone: true,
          Website: true,
          NameFound: "Hungry Lion Eloff Street",
          AddressFound: "Address: 80 Eloff St, Hillbrow, Johannesburg, 2000",
        },
        {
          Platform: "facebook",
          Present: true,
          CorrectName: true,
          Address: true,
          CorrectAddress: false,
          Phone: true,
          Website: false,
          NameFound:
            "Hungry Lion Eloff Street\n@hungrylioneloffstreet\n\u00a0\n \u00b7 Fast food restaurant",
          AddressFound: "80 Eloff Street 2000 Johannesburg, South Africa",
        },
        {
          Platform: "cylex",
          Present: true,
          CorrectName: true,
          Address: true,
          CorrectAddress: false,
          Phone: true,
          Website: true,
          NameFound: "Hungry Lion",
          AddressFound: "80 ELOFF ST, SELBY, Johannesburg, 2001",
        },
        {
          Platform: "tomtom",
          Present: true,
          CorrectName: true,
          Address: true,
          CorrectAddress: false,
          Phone: false,
          Website: true,
          NameFound: "Hungry Lion",
          AddressFound: "80 Eloff Street, Johannesburg, 2001",
        },
        {
          Platform: "Bing",
          Present: true,
          CorrectName: true,
          Address: true,
          CorrectAddress: false,
          Phone: false,
          Website: false,
          NameFound: "Hungry Lion Eloff Street",
          AddressFound: "80 Eloff St East London 2001",
        },
        {
          Platform: "yellowpages",
          Present: false,
          CorrectName: false,
          Address: false,
          CorrectAddress: false,
          Phone: false,
          Website: false,
          NameFound: "None",
          AddressFound: "None",
        },
        {
          Platform: "foursquare",
          Present: false,
          CorrectName: false,
          Address: false,
          CorrectAddress: false,
          Phone: false,
          Website: false,
          NameFound: "None",
          AddressFound: "None",
        },
        {
          Platform: "here",
          Present: false,
          CorrectName: false,
          Address: false,
          CorrectAddress: false,
          Phone: false,
          Website: false,
          NameFound: "None",
          AddressFound: "None",
        },
      ];
    },
  },
};
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
